<div class="d-flex justify-content-center">
  <img class="cannot-select-image" width="250" src="/assets/images/no-data/no_data.png" >
</div>
<div class="d-flex justify-content-center">
  <div class="no-data mt-0">{{ displayTranslatedString | translate }}</div>
</div>